


import Terrain from '../../terrain/Terrain'
import GlassTerrain from '../../terrain/GlassTerrain'
import MotelTerrain from '../../terrain/MotelTerrain'
import InvSearchBoardBody from './invBoardBody'
import InvSearchBoardBodyPg from './invBoardBodyPg'
//import FacetBar from '../../esfind/FacetBar'
import InvSJScroll from './invSJScroll'
import TerrainStars from '../../terrain/TerrainStars'
import {  Link } from "react-router-dom"
import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner';

import {InvSearchBarBusCom, InvFacetBarBusCom} from '../../../containers'
import SJPageScroll from '../../../views/SJPageScroll'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
import { Icon, Button, Row, Col, Badge } from 'antd';

import SojTerrainLocationSVPriceListView from '../../sojterrain/SojTerrainLocationSVPriceListView'
//import InvSearchBoardBody from './InvSearchBoardBody'
 import '../../../css/svlist_styles.css'

 import { v4 as uuidv4 } from 'uuid';

 import history from "../../../history"
import SJScroll from './invBoardBodyPgListScroll'
 

const React = require('react')
const _ = require('lodash')

 
const HeartSvg = () => (
 <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
   <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
 </svg>
);

const HeartIcon = props => <Icon component={HeartSvg} {...props} />;


class InvSearchBoardContainer extends React.Component {
 sjprobatecourtselectparent(valuesChild,soj_rate_key ){
     let me = this
   console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  OCT28  1 cookie1 from AmbLocation callback  flyboard svofferselectparent**********parent')
   console.log(valuesChild)
   let spaceKey = valuesChild['spaceKey']
  
   const { cookies } = this.props;
   console.log('sv*** MARCH27SV localStorage start')
   console.log(cookies)
   console.log('sv*** MARCH27SV localStorage end')
 
  /*
   const { cookies , localStorage} = this.props;
  console.log('sv*** MARCH27SV localStorage start')
  console.log(localStorage)
  console.log('sv*** MARCH27SV localStorage end')
*/
   if(cookies){
       let sjcookoffer_o = null
       console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')

       if(valuesChild ){
             console.log('********NOV19**************** sv START ')
         let sjcookoffer_val = {}
         
           
           let svcustProfile_newcustomer = {
             "customerId": -6,
             "addressId":-1
         }
         //room selection is first room . UI screen for roomtype selection needed
         let svvc = {}
         let asset = valuesChild.assets[0]
         let obroom = {
             "code":asset.code,
             "name":asset.name,
             rates: []
         }
         obroom.rates.push(asset.rates[0])

          let ratekey = asset.rates[0].rateKey 
          svvc.rateKey = ratekey
          svvc.code = valuesChild['spacekey']
          svvc.reviews =valuesChild['reviews']
          svvc.room = obroom
          svvc.svrate= asset.rates[0]
          console.log('svvc**may25', svvc)
          svvc.svcustProfile = svcustProfile_newcustomer
          if(!valuesChild['svcustProfile']){
             valuesChild['svcustProfile'] = svcustProfile_newcustomer
          }
/*
         
          let svaluesChild = JSON.stringify(valuesChild)
          */
          let svaluesChild = JSON.stringify(svvc)
          let size = svaluesChild.length
          console.log('********OCT25**************** SIZE OF  COOKIES  svcookoffer ', size)

          /*svnov20 start*/
          //we need to save in db based on sessionid or jwttoken genereate
          //and get that
          /*
          let toffer = valuesChild
          if(toffer && toffer["travelerPricings"] && toffer["travelerPricings"] ){
              let tars = toffer["travelerPricings"]
              for(let m=0; m <  tars.length; m++){
                  delete tars[m].fareDetailsBySegment
              }
          }
          */
         /*svnov20 start*/
          
           

         
           try{
               /*
             console.log(localStorage)
             localStorage.setItem('svcookls', svaluesChild);
             cookies.set('svcook', svaluesChild, { path: '/' });
             */
             cookies.set('sjcook', svaluesChild, { path: '/' });

           }catch(error){
             console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')

                console.log(error)}
          

           let m_offer = cookies.get('sjcook')
           console.log('********OCT25**************** TEST TO COOKIES SET sjcookoffer START', m_offer)
           /*svdec2 start */
           let my_data_sjtoffee ={
             "customerId": valuesChild['svcustProfile']['customerId'] ,
             "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
             "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
         } 
         my_data_sjtoffee.sjcook = svaluesChild
         console.log('********DEC4**************** expresseion sesion START ')
         /*
         save to redis
         this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
          

         */
         let expsessid_svt_s =  cookies.get('svabodeclientguest')
         console.log(expsessid_svt_s);
         
         let m_svt = expsessid_svt_s
         if(m_svt != null){
             my_data_sjtoffee['svt'] = m_svt
         }
         console.log('********DEC4**************** TEST TO COOKIES SET my_data_sjtoffee ')
         console.log(my_data_sjtoffee)
         console.log('********DEC4**************** expresseion sesion START ')
         
         // this.props.saveUserOffer({'my_data_sjtoffee' :my_data_sjtoffee})
          
         /*svdec2 end*/
           
        
         const udob ={
             "svcid": -2,
             "soj_rate_key":soj_rate_key,
             "code": valuesChild["spacekey"] ,
             "room": obroom
             
         
         }

       
         _.delay(()=>{
             /*
             console.log('sv****calling delauy DEC3 START'  )
             const { soj_rate_key} = udob
             let surl = `/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`
             console.log(surl)
             console.log('sv****calling delauy May26 end' )
              history.push(`/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`)
    
             */
              console.log('sv****calling delauy DEC3 START'  )
              const { soj_rate_key} = udob
              const { code} = udob
              let surl = `/inetsojourn/shredbook/${code}`
            // let surl = `/inetsojourn/shredfly/${code}`
             console.log(surl)
             console.log('sv****calling delauy DEC3 END' )
             history.push(`/isjpb/pbwilbook/${code}`)
             //history.push(`/inetsojourn/shredfly/${code}`)
            
            /*svamy26mon  passing id and spaceKey to ShyReserveWithSearchPage wich calls SJReview*/
                }, 400, udob);

         // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)

       }else{
           console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')

       }
       

   }
 
 }
 sjofferselectparent(valuesChild,soj_rate_key ){
     let me = this
   console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  OCT28  1 cookie1 from AmbLocation callback  flyboard svofferselectparent**********parent')
   console.log(valuesChild)
   let spaceKey = valuesChild['spaceKey']
  
   const { cookies } = this.props;
   console.log('sv*** MARCH27SV localStorage start')
   console.log(cookies)
   console.log('sv*** MARCH27SV localStorage end')
 
  /*
   const { cookies , localStorage} = this.props;
  console.log('sv*** MARCH27SV localStorage start')
  console.log(localStorage)
  console.log('sv*** MARCH27SV localStorage end')
*/
   if(cookies){
       let sjcookoffer_o = null
       console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')

       if(valuesChild ){
             console.log('********NOV19**************** sv START ')
         let sjcookoffer_val = {}
         
           
           let svcustProfile_newcustomer = {
             "customerId": -6,
             "addressId":-1
         }
         //room selection is first room . UI screen for roomtype selection needed
         let svvc = {}
         let asset = valuesChild.assets[0]
         let obroom = {
             "code":asset.code,
             "name":asset.name,
             rates: []
         }
         obroom.rates.push(asset.rates[0])

          let ratekey = asset.rates[0].rateKey 
          svvc.rateKey = ratekey
          svvc.code = valuesChild['spacekey']
          svvc.reviews =valuesChild['reviews']
          svvc.room = obroom
          svvc.svrate= asset.rates[0]
          console.log('svvc**may25', svvc)
          svvc.svcustProfile = svcustProfile_newcustomer
          if(!valuesChild['svcustProfile']){
             valuesChild['svcustProfile'] = svcustProfile_newcustomer
          }
/*
         
          let svaluesChild = JSON.stringify(valuesChild)
          */
          let svaluesChild = JSON.stringify(svvc)
          let size = svaluesChild.length
          console.log('********OCT25**************** SIZE OF  COOKIES  svcookoffer ', size)

          /*svnov20 start*/
          //we need to save in db based on sessionid or jwttoken genereate
          //and get that
          /*
          let toffer = valuesChild
          if(toffer && toffer["travelerPricings"] && toffer["travelerPricings"] ){
              let tars = toffer["travelerPricings"]
              for(let m=0; m <  tars.length; m++){
                  delete tars[m].fareDetailsBySegment
              }
          }
          */
         /*svnov20 start*/
          
           

         
           try{
               /*
             console.log(localStorage)
             localStorage.setItem('svcookls', svaluesChild);
             cookies.set('svcook', svaluesChild, { path: '/' });
             */
             cookies.set('sjcook', svaluesChild, { path: '/' });

           }catch(error){
             console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')

                console.log(error)}
          

           let m_offer = cookies.get('sjcook')
           console.log('********OCT25**************** TEST TO COOKIES SET sjcookoffer START', m_offer)
           /*svdec2 start */
           let my_data_sjtoffee ={
             "customerId": valuesChild['svcustProfile']['customerId'] ,
             "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
             "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
         } 
         my_data_sjtoffee.sjcook = svaluesChild
         console.log('********DEC4**************** expresseion sesion START ')
         /*
         save to redis
         this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
          

         */
         let expsessid_svt_s =  cookies.get('svabodeclientguest')
         console.log(expsessid_svt_s);
         
         let m_svt = expsessid_svt_s
         if(m_svt != null){
             my_data_sjtoffee['svt'] = m_svt
         }
         console.log('********DEC4**************** TEST TO COOKIES SET my_data_sjtoffee ')
         console.log(my_data_sjtoffee)
         console.log('********DEC4**************** expresseion sesion START ')
         
         // this.props.saveUserOffer({'my_data_sjtoffee' :my_data_sjtoffee})
          
         /*svdec2 end*/
           
        
         const udob ={
             "svcid": -2,
             "soj_rate_key":soj_rate_key,
             "code": valuesChild["spacekey"] ,
             "room": obroom
             
         
         }

       
         _.delay(()=>{
             /*
             console.log('sv****calling delauy DEC3 START'  )
             const { soj_rate_key} = udob
             let surl = `/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`
             console.log(surl)
             console.log('sv****calling delauy May26 end' )
              history.push(`/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`)
    
             */
              console.log('sv****calling delauy DEC3 START'  )
              const { soj_rate_key} = udob
              const { code} = udob
              let surl = `/inetsojourn/shredbook/${code}`
            // let surl = `/inetsojourn/shredfly/${code}`
             console.log(surl)
             console.log('sv****calling delauy DEC3 END' )
             history.push(`/inetsojourn/shredbook/${code}`)
             //history.push(`/inetsojourn/shredfly/${code}`)
            
            /*svamy26mon  passing id and spaceKey to ShyReserveWithSearchPage wich calls SJReview*/
                }, 400, udob);

         // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)

       }else{
           console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')

       }
       

   }
 
 }
 //sjjul14 start
 sjhotelselectparent(valuesChild,soj_rate_key ){
     let me = this
   console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  OCT28  1 cookie1 from AmbLocation callback  flyboard svofferselectparent**********parent')
   console.log(valuesChild)
   let spaceKey = valuesChild['spaceKey']
  
   const { cookies } = this.props;
   console.log('sv*** MARCH27SV localStorage start')
   console.log(cookies)
   console.log('sv*** MARCH27SV localStorage end')
 
  /*
   const { cookies , localStorage} = this.props;
  console.log('sv*** MARCH27SV localStorage start')
  console.log(localStorage)
  console.log('sv*** MARCH27SV localStorage end')
*/
   if(cookies){
       let sjcookoffer_o = null
       console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')

       if(valuesChild ){
             console.log('********NOV19**************** sv START ')
         let sjcookoffer_val = {}
         
           
           let svcustProfile_newcustomer = {
             "customerId": -6,
             "addressId":-1
         }
         //room selection is first room . UI screen for roomtype selection needed
         let svvc = {}
         let asset = valuesChild.assets[0]
         let obroom = {
             "code":asset.code,
             "name":asset.name,
             rates: []
         }
         obroom.rates.push(asset.rates[0])

          let ratekey = asset.rates[0].rateKey 
          svvc.rateKey = ratekey
          svvc.code = valuesChild['spacekey']
          svvc.reviews =valuesChild['reviews']
          svvc.room = obroom
          svvc.svrate= asset.rates[0]
          console.log('svvc**may25', svvc)
          svvc.svcustProfile = svcustProfile_newcustomer
          if(!valuesChild['svcustProfile']){
             valuesChild['svcustProfile'] = svcustProfile_newcustomer
          }
/*
         
          let svaluesChild = JSON.stringify(valuesChild)
          */
          let svaluesChild = JSON.stringify(svvc)
          let size = svaluesChild.length
          console.log('********OCT25**************** SIZE OF  COOKIES  svcookoffer ', size)

          /*svnov20 start*/
          //we need to save in db based on sessionid or jwttoken genereate
          //and get that
          /*
          let toffer = valuesChild
          if(toffer && toffer["travelerPricings"] && toffer["travelerPricings"] ){
              let tars = toffer["travelerPricings"]
              for(let m=0; m <  tars.length; m++){
                  delete tars[m].fareDetailsBySegment
              }
          }
          */
         /*svnov20 start*/
          
           

         
           try{
               /*
             console.log(localStorage)
             localStorage.setItem('svcookls', svaluesChild);
             cookies.set('svcook', svaluesChild, { path: '/' });
             */
             cookies.set('sjcook', svaluesChild, { path: '/' });

           }catch(error){
             console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')

                console.log(error)}
          

           let m_offer = cookies.get('sjcook')
           console.log('********OCT25**************** TEST TO COOKIES SET sjcookoffer START', m_offer)
           /*svdec2 start */
           let my_data_sjtoffee ={
             "customerId": valuesChild['svcustProfile']['customerId'] ,
             "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
             "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
         } 
         my_data_sjtoffee.sjcook = svaluesChild
         console.log('********DEC4**************** expresseion sesion START ')
         /*
         save to redis
         this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
          

         */
         let expsessid_svt_s =  cookies.get('svabodeclientguest')
         console.log(expsessid_svt_s);
         
         let m_svt = expsessid_svt_s
         if(m_svt != null){
             my_data_sjtoffee['svt'] = m_svt
         }
         console.log('********DEC4**************** TEST TO COOKIES SET my_data_sjtoffee ')
         console.log(my_data_sjtoffee)
         console.log('********DEC4**************** expresseion sesion START ')
         
         // this.props.saveUserOffer({'my_data_sjtoffee' :my_data_sjtoffee})
          
         /*svdec2 end*/
           
        
         const udob ={
             "svcid": -2,
             "soj_rate_key":soj_rate_key,
             "code": valuesChild["spacekey"] ,
             "room": obroom
             
         
         }

       
         _.delay(()=>{
             /*
             console.log('sv****calling delauy DEC3 START'  )
             const { soj_rate_key} = udob
             let surl = `/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`
             console.log(surl)
             console.log('sv****calling delauy May26 end' )
              history.push(`/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`)
    
             */
              console.log('sv****calling delauy jul14 y25  START'  )
              const { soj_rate_key} = udob
              const { code} = udob
              let surl = `/inetsojourn/shredbook/${code}`
            // let surl = `/inetsojourn/shredfly/${code}`
             console.log(surl)
             console.log('sv****calling saved cookie for reate sjcook delauy jul14 y25 END' )
             ///inetsojourn/svredsojourn/ hotel page
             history.push(`/inetsojourn/svredsojourn/${code}`)
             //history.push(`/inetsojourn/shredfly/${code}`)
            
            /*svamy26mon  passing id and spaceKey to ShyReserveWithSearchPage wich calls SJReview*/
                }, 400, udob);

         // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)

       }else{
           console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')

       }
       

   }
 
 }
 //sjjul14 end
 constructor(props) {
     super(props)
     let me = this
     /*shjun19 start*/
     this.getBoardBodyContainer_soj = this.getBoardBodyContainer_soj.bind(me)
     
    /*svmay24 start*/
    this.sjprobatecourtselectparent = this.sjprobatecourtselectparent.bind(me)
    this.sjofferselectparent = this.sjofferselectparent.bind(me)
    this.sjhotelselectparent = this.sjhotelselectparent.bind(me)

    //sjhotelselectparent

    /*svmay24 end*/
     this.getAppDetails = this.getAppDetails.bind(this)
     this.getAppDetailsMyReservation = this.getAppDetailsMyReservation.bind(this)
     
     this.getMyHtml = this.getMyHtml.bind(this)
     this.getReserveHtmlButton = this.getReserveHtmlButton.bind(this)
     this.svsojourns = []
     this.title = 'PROD-NON-PROD Symmetry'
     this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
     this.getChildContainers = this.getChildContainers.bind(me)
     this.getChildContainersList = this.getChildContainersList.bind(me)
     this.getBedroomDetails = this.getBedroomDetails.bind(me)
     this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)

     this.starBody = this.starBody.bind(this)
 }
 starBody(o){
     let svrstars = {
         "sv_rating_no":o.avg_stars_rating ? o.avg_stars_rating : 5  ,
         "color": "#e8a01899"
     }
     return(<TerrainStars svrstars={svrstars} ></TerrainStars>)

 }
 /*
 onChangeCbParking=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f['checkedParking'] =e.target.checked

     this.setState({filters:f} )

 }

 onChangeCbWifi=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f['checkedWifi'] =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbRestaurant=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedRestaurant =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbPetfriendly=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedPetfriendly =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbRoomservice=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedRoomservice =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbFrontdesk=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedFrontdesk =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbFitness=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedFitness =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbNonsmoking=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedNonsmoking =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbShuttle=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedShuttle =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbFamilyrooms=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedFamilyrooms =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbSpa=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedSpa =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbEvcharging=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedEvcharging =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbWheelchair=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedWheelchair =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbPool=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f.checkedPool =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbWifi=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f['checkedWifi'] =e.target.checked

     this.setState({filters:f} )

 }
 onChangeCbWifi=(e)=>{
     console.log('checked = ', e.target.checked);
      let f = this.state.filters
      f['checkedWifi'] =e.target.checked

     this.setState({filters:f} )

 }
 */
 deleteTaskCurryParams = (param1, ctx)=>(event)=>{
     console.log(param1)
     let me = ctx
     me.currentSelection = param1.sojourncode
     console.log('sv delete task curry')
     console.log(param1.sojourncode)
     //me.props.svWrappedDeleteTaskActionCreator(param1.id)
 }
 getBedroomDetails = (s, ctx)=>(event)=>{

     const det = 'Ssandara Queen Room with '
     console.log('sv**currryy' + s)
     s = (s? s : '2')
     if (s =='4'){
         return  det + '4' + 'Rooms'
     }else{
         return  det + s + 'Rooms'
     }

 }
 getAppDetailsMyReservation(paramQSpaceId, svcustProfile){
     console.log('caall getAppDetailsMyReservation', paramQSpaceId,svcustProfile)
     
     const shrq = {
 
         "dates": {
             "STARTDATE_ITN_TZAWARE_EST": "2025-04-19",
             "ENDDATE_ITN_TZAWARE_EST": "2025-04-25",
             "DT_FORMAT": "%Y-%m-%d",
             "time_zone": "Asia/Kolkata",
             "OP": "range"
         },
         "facets": {
                "PMSRoomCode": "APT"
             },
         "useCity":true,
         "dst": "PLAYA DE LAS AMERICAS",
         "esqueryChilds": "m0",
         "esqueryInfants": "i0",
         "esqueryAdults": "t1",
         "esqueryCabin": "ECONOMY",
         "esqueryTripType": "roundtrip",
         "svpageSize": 5
     }
     const sjrqOld = {
         "hotelIds": "HLPAR266",
         "adults": 1,
         "checkInDate": "2025-11-22",
         "roomQuantity": 1
     }
     const sjrq = {
         "svfields": [
             "images",
             "sojourn_name",
            // "address",
            
             "code",
             "sojournGeocode",
             "categoryCode",
             "categoryGroupCode",
             "accommodationTypeCode",
     
             "sojourn_city",
             "countryCode",
             "stateCode",
             "postalCode",
              "countryCode",
             "destinationCode"
             
         ],
     
            "dates": {
                 "STARTDATE_ITN_TZAWARE_EST": "2025-04-19",
                 "ENDDATE_ITN_TZAWARE_EST": "2025-04-25",
                 "DT_FORMAT": "%Y-%m-%d",
                 "time_zone": "Asia/Kolkata",
                 "OP": "range"
             },
             "facets": {
                 "PMSRoomCode": "APT"
                 },
             "useCity":true,
             "dst": "PLAYA DE LAS AMERICAS",
             "esqueryChilds": "m0",
             "esqueryInfants": "i0",
             "esqueryAdults": "t1",
             "esqueryCabin": "ECONOMY",
             "esqueryTripType": "roundtrip",
             "svpageSize": 5
         }

    
     //this.props.sojDetailsAndImagesSV("mancreek") 
     /*this.props.getSojournDetails("mancreek") */
    // this.props.sojAndImagesSojourn(sjrq)
 }
 getAppDetails(paramQ){
     
    // this.props.getSoDetails("mancreek")

    this.props.sojAndImagesSojourn("mancreek")
    
 }
 componentWillMount()	{
     console.log('=---json')
     
     const { cookies } = this.props;
    
     if(cookies){
         let sguestchild = uuidv4()
         cookies.set('sjcook', sguestchild, { path: '/' });
     }
     
     let svsojourns = [
     
         {
             "name": "3",
             "id": 3,
             "selected": false,
             "age": 32,
             "species": "Stego"
         },
         {
             "name": "4",
             "id": 4,
             "selected": false,
             "age": 13,
             "species": "T. Rex"
         }
     ]
     console.log('**sv sohourns got from service ********')
     console.log(svsojourns)
     /* this.state = {
               tasks: svtasks
         }*/
//sv step1 dipatch action  dispatch is warpper with actiobcreateer by redux
//sv step2 reduce gives you new state that is available as props to render method
             console.log('sv--tasks')
             this.svsojourns = svsojourns
             var ar = svsojourns;
               //this.props.svWrappedfetchSVESSearchActionCreator(ar)
         this.getAppDetails('mancreek')
         
         
 

 }

  getMyHtml(){
     let ar = this.state.my_data;
     
     console.log(this.state)
     console.log(ar);
     const my_data = this.state.my_data;
     return my_data.map(o => {
         console.log(o)
         return (<li>{o.name}</li>)
     });
 }

 getReserveHtmlButton(o,customerId){
     if(customerId > 0){
         return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/reservesvCustNew/${o.space_key}`}> MyReserve  </Link></Button>)
         

     }else{

         return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/inetsojourn/shredbook/${o.space_key}`}> Reserve  </Link></Button>)
         
     }
     
 }
 getHotelAmenityList(ar){
     
     
     ar = ar || []
    return ar.map( (v, idx)=>{
        if(v.toLocaleLowerCase() == "swimming beach"){
         return (<span style={{fontSize: "14px"}} > <HeartIcon style={{ color: 'hotpink' }} /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
     
        }else if(v.toLocaleLowerCase() == "tennis"){  
         return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122196' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
     

        }else if(v.toLocaleLowerCase() == "water"){  
         return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#522f96' }} type="video-camera" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
     

        }else{

         return (<span style={{fontSize: "14px"}} > <Icon  style={{ color: '#122f96' }} type="audio" theme="filled" /><text style={{paddingLeft: "10px"}}>{v}</text></span>)
     
        }
       })
    


 }

 getChildContainers() {
     const legend = [{
         "sojourncode": "100",
         "vernacularcode": "EN",
         "sojourn_name": "253 Mancreek Resort"
     },
     {
         "sojourncode": "101",
         "vernacularcode": "EN",
         "sojourn_name": "253 John Resort"
     }]
     let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
     if (this.props.data && (this.props.data.length > 0)) {
         data = this.props.data
     }
     if (this.props.sojourns && (this.props.sojourns.length > 0)) {
         sojourns = this.props.sojourns

         console.log('sv******************this.props')
         console.log(this.props)

         console.log('sv******************this.props....')
     }
     if (this.props.my_data && (this.props.my_data.length > 0)) {
         my_data = this.props.my_data
     }
     /*
     if (this.props.loading) {
         return <Loader type='spinner' />
     } else if (this.props.error) {
         return <ErrorWidget error={this.props.error} />
     }
     */
     return (
         <div>


<div className="box-outer-listhotels">
 <div className="box-left-listhotels">
     <p>
         
         <text className="f24" >SV Cambria Hotel Oraland </text>
         <span className="f12" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>
        
     </p>
    
 </div>

 <div className="box-right-listhotels">
   
     <p>
         <text   className="f19">Excellent </text>
         <text className="f12 d-block"  >12345 reviews </text>
         <span className="f12 sv-hide" >Oralndo  <text>Shown On map</text> <text>4  iles away</text></span>
         
     </p>
    
     
 </div>
</div>


<div className="box-outer-listhotels">
 <div className="box-left-listhotels">
     <p>
         
         <text className="f19"> Standard Queen Room With two Queen Rooms & shower </text>
         <text className="f12"> 2 Queen Beds </text>
         
     </p>

 </div>

 <div className="box-right-listhotels">
   
     <p>
         <text   className="f19">1night, 2days </text>
         <text   className="f22 d-block">$116 </text>
        
         
     </p>
     
 </div>
</div>
<div className="box-outer-listhotels">
 <div className="box-left-listhotels">
     <p>
         
         <text className="f19"> Only 8  Rooms left </text>
        
         
     </p>

 </div>

 <div className="box-right-listhotels">
   
     <p>
        
        
         
     </p>
     
 </div>
</div>
         
         </div>
        
         
         )
 }

 getChildContainersOld() {
     const legend = [{
         "sojourncode": "100",
         "vernacularcode": "EN",
         "sojourn_name": "253 Mancreek Resort"
     },
     {
         "sojourncode": "101",
         "vernacularcode": "EN",
         "sojourn_name": "253 John Resort"
     }]
     let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
     if (this.props.data && (this.props.data.length > 0)) {
         data = this.props.data
     }
     if (this.props.sojourns && (this.props.sojourns.length > 0)) {
         sojourns = this.props.sojourns

         console.log('sv******************this.props')
         console.log(this.props)

         console.log('sv******************this.props....')
     }
     if (this.props.my_data && (this.props.my_data.length > 0)) {
         my_data = this.props.my_data
     }
     /*
     if (this.props.loading) {
         return <Loader type='spinner' />
     } else if (this.props.error) {
         return <ErrorWidget error={this.props.error} />
     }
     */
     return (
         <div>

<a target="_blank" rel="noopener noreferrer" href="https://www.booking.com/hotel/us/san-diego-del-mar.html?label=gen173nr-1FCAEoggI46AdIM1gEaIkCiAEBmAExuAEYyAEP2AEB6AEB-AECiAIBqAIEuAKNu_CxBsACAdICJGY4NTJhN2NkLTkxMmItNDE1Zi04ZGI4LTVjYWRjNDU2N2M3NNgCBeACAQ&amp;aid=304142&amp;ucfs=1&amp;arphpl=1&amp;checkin=2024-05-24&amp;checkout=2024-06-07&amp;dest_id=20015725&amp;dest_type=city&amp;group_adults=2&amp;req_adults=2&amp;no_rooms=1&amp;group_children=0&amp;req_children=0&amp;hpos=1&amp;hapos=1&amp;sr_order=popularity&amp;srpvid=025e05dca08401b2&amp;srepoch=1715217706&amp;all_sr_blocks=26285401_246425381_0_42_0&amp;highlighted_blocks=26285401_246425381_0_42_0&amp;matching_block_id=26285401_246425381_0_42_0&amp;sr_pri_blocks=26285401_246425381_0_42_0__250600&amp;from_sustainable_property_sr=1&amp;from=searchresults&amp;map=1" className="a83ed08757 f88a5204c2 a1ae279108 b98133fb50"><span><span className="aee5343fdb def9bc142a" data-testid="address">Carmel Valley, San Diego</span><span className="aee5343fdb def9bc142a">Show on map</span></span></a><span className="aee5343fdb"><span className="f419a93f12"><span aria-expanded="false" data-testid="distance">16.1 miles from downtown</span></span></span><span className="aee5343fdb"><span className="f419a93f12"><span aria-expanded="false">Beach Nearby</span></span></span>

             {

                  my_data.map(o => {
                     console.log(o)
                     return (<li>{o.sojourn_name}</li>)
                 })
             }
         </div>
        
         
         )
 }

 

 render() {
     const lastestUpdateDate = 'Data Refresh Daily'
     /*
     const { cookies } = this.props;
     let sjcookoffer_val = "yyXX"
     //save here the rquest ibject
     console.log('********OCT25**************** COOKIES SET sjcookoffer START')

     if(cookies ){
         cookies.set('sjcookoffer', sjcookoffer_val, { path: '/' });
     }else{
         console.log('********OCT25****************FAILED to set cookies bull *** COOKIES SET sjcookoffer START')

     }
     */

       return (

         
         <div className="col-md-12">

 
             
             <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersList()}></MotelTerrain>
         </div>
     )
     
 }


 getChildContainersList_org() {
   
     /*
             const {
             checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
             disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
             checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
             checkedParking,checkedParkingLabel,disabledParking
     
     
             } = this.state.filters
             */
            const size = 'small'
             const legend = [{
                 "sojourncode": "100",
                 "vernacularcode": "EN",
                 "sojourn_name": "253 Mancreek Resort"
             },
             {
                 "sojourncode": "101",
                 "vernacularcode": "EN",
                 "sojourn_name": "253 John Resort"
             }]
             let customerId = -1
             let svCustomerId = -1
             const {dataProfile, svcustProfile} = this.props
             if(svcustProfile && svcustProfile.customerId > 0){
                 customerId = svcustProfile.customerId 
                 svCustomerId = customerId
                 console.log('myreservationSpace')
                 }else{
                  console.log('internet userSpace')
                 }
             let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
             if (this.props.sosjournsearch.data && (this.props.sosjournsearch.data.length > 0)) {
                 data = this.props.sosjournsearch.data
             }
             if (this.props.sosjournsearch.sojourns && (this.props.sosjournsearch.sojourns.length > 0)) {
                 sojourns = this.props.sosjournsearch.sojourns
     
                 console.log('sv******************this.props')
                 console.log(this.props)
     
                 console.log('sv******************this.props....')
             }
             if (this.props.sosjournsearch && this.props.sosjournsearch.my_data && (this.props.sosjournsearch.my_data.length > 0)) {
                 my_data = this.props.sosjournsearch.my_data
             }else if(this.props.my_data && (this.props.my_data.length > 0)){
                 my_data = this.props.my_data
             }
     
             const {svessearch, locationDataView} = this.props
             console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
             console.log(this.props)
             console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
             /*
             if (this.props.loading) {
                 return <Loader type='spinner' />
             } else if (this.props.error) {
                 return <ErrorWidget error={this.props.error} />
             }
             */
            let testimonyO = {
             avg_stars_rating :5
            }
             return (
                 <div className="svr-det-pageWrapper">
                 <header className="svr-header1">
                 <h1><span><text style={{color:'#f0d8a9'}}>Sojourn Inventory List View </text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                 </header>
                 <InvSearchBarBusCom />
                 
                 {/*  
                 <SearchBarBusCom />
                 <header className="svr-header2">
                     <h3>Cambsv Hotel Orlando Airport</h3>
                     <p> 7986 Conway Road, Orlando, 32812, United States of America – Excellent location – show map </p>
                 </header>
                 */}
             
             
                 <div className="svr-spacelist-contentWrapper">
                     <article className="main-listhotels">
                     {
                             my_data.map(o => {
                                 let soj = o
                                 //convet keys of o to uppercase
                                 console.log('sv***soj**')
                                 console.log(soj)
                                 let assets_ob = soj["assets"]
                     if( assets_ob &&  assets_ob.length > 0){
                         soj['roomMeta']  = assets_ob[0]["name"]
                         soj['roomsAvailable'] = assets_ob.length
                     }else{
                         soj['roomMeta']  = "2 SVQueen Bed"
                         soj['roomsAvailable']  = 0
                     }
                                 let roomImgs = soj['imgs']
                                 let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
                                 if(roomImgs && (roomImgs.length > 0)) {
                                      roomImg = roomImgs[0]
                                 }
                                 
                                 console.log('sv888MAY6888IMGS', roomImg);

                                 let terminals = soj["hotel"]['terminals']
                                 let terminalOld = {"terminalCode": "MLS", "distance":87}
                                 let terminal = null
                                 if(terminals && (terminals.length > 0)) {
                                      terminal = terminals[0]
                                 }
                                 //sv room
                                 let rooms = soj["hotel"]['rooms']
                                 
                                 let room = null
                                 let roomConent  =''
                                 if(rooms && (rooms.length > 0)) {
                                      room = rooms[0]
                                      let { roomStays} = room
                                      if (roomStays){
                                         roomStays.forEach( stay => {
                                             roomConent = roomConent + `${stay.order} ${stay.stayType}`

                                         })
                                      }
                                      roomConent = `${roomConent} - ${room.roomType}` 
                                 }else{
                                     o.bedroomcode = o.bedroomcode ? o.bedroomcode : "2"
                                     roomConent = `${o.bedroomcode} SVQueen Beds`
                                     
                                 }
                                 soj["roomConent"] = roomConent

                                 //let terminalContent = `${terminal.distance} miles from ${terminal.terminalCode}`
                                 
                                 console.log('sv888MAY6888IMGS', roomImg);
                                 
                                 let priceInfo = {
                                     o:o,
                                    
                                     customerId:customerId
                                 }
                                 let reservekey = 'insvreview'
                                 let svr_location = {
                                     "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
                                     "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
                                     "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
                                     "county": soj['county'] ? soj['county'] : "albanyt",
                                     "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
                                     "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
                                     "country": soj['country_name'] ? soj['country_name'] : "usa",
                                    "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
                                    "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
                                     
                                    "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
                                    "state":soj['state'] ? soj['state'] : "NY"
     
                                 }
                                 
                                 if(terminal != null){
                                     svr_location["nearest_airport_distance_mi_lvl"] = terminal.distance
                                     svr_location["en_nearest_airports_lvl"] = terminal.terminalCode
                                 }
                                 return (
                                     <div className="svr-spacelist-box-row1">
                                     <div className="svr-spacelist-boxr-1">
                                         <div className="gallery">
                                             <figure>
                                             <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                                             {/* <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                              */}
                                             <img src={`${roomImg}`} alt="Carpet Grass" />
                                              </Link> </span>
                                                 
                                             </figure>
                                         </div>
                                     </div>
                     
                                     <SojTerrainLocationSVPriceListView priceInfo={priceInfo} svcustProfile={svcustProfile} reservekey={reservekey}  svrlocation={svr_location}></SojTerrainLocationSVPriceListView>

                                 </div>
                                     
                                 )
                             })
                         }
                        
                         <div className="svr-spacelist-box-row1 svr-spacelist-box-row1-last">
                             <div className="svr-spacelist-boxr-1">
                                 <div className="gallery">
                                     <figure>
                                     <span>	<Link to={`/svredsojourn`} > 
                                     
                                     <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                      </Link> </span>
                                        
                                     </figure>
                                 </div>
                             </div>
             
                             <div className="svr-spacelist-boxl-2">
                                 <div className="box-outer-listhotels">
                                     <div className="box-left-listhotels">
                                         <p className="m-para-text-first">
                                             <text className="svr-hotel-name">SV Cambria Hotel Oraland </text>
                                             <span className="ter-l2 svr-hotel-location">Oralndo <text>Shown On map</text> <text>4 iles
                                                     away</text></span>
                                            
                                         </p>
                                     </div>
                                     <div className="box-right-listhotels">
                                         <p className="m-para-text-first">
                                             <text className="svr-hotel-rating">Excellent </text>
                                             <text className="f12 d-block">12345 reviews </text>
                                         </p>
                                     </div>
                                 </div>
             
             
                                 <div className="box-outer-listhotels">
                                     <div className="box-left-listhotels">
                                         <p className="m-para-text">
                                             <text className="svr-hotel-room"> Standard Queen Room With two Queen Rooms & shower </text>
                                             <text className="f12  d-block"> 2 Queen Beds </text>
                                         </p>
                                     </div>
                                     <div className="box-right-listhotels">
                                         <p className="m-para-text">
                                             <text className="svr-hotel-stay">1night, 2days </text>
                                             <text className="svr-hotel-price d-block">$116 </text>
                                         </p>
                                     </div>
                                 </div>
                                 
                                 <div className="box-outer-listhotels">
                                     <div className="box-left-listhotels">
                                         <p className="svr-hotel-avail">
                                             <text className="f19"> Only 8 Rooms left </text>
                                         </p>
                                     </div>
                                     <div className="box-right-listhotels">
                                         <p>
                                       
                                         </p>
                                     </div>
                                 </div>
             
             
                             </div>
             
             
                         </div>
                     </article>
             
                    
                     <aside className="siberbar2">
             
                         <h3> Filter By</h3>
                         <InvFacetBarBusCom  locationDataView={locationDataView} />
                         {/* <FacetBarBusCom  locationDataView={locationDataView} /> */}
                         <div className="svr-rating-content">
                             <p className="svr-hotel-rating" >Excelllent 5.0
                             </p>
             
                         </div>
             
                         <div className="svr-num-reviews-content">
                             <p>12,364 reviews
                             </p>
             
                         </div>
                         <div className="svr-review-author-comment-content">
             
                             <p>“The property has a great bar/restaurant in the lobby, which is good because there isn't much
                                 around
                                 there to choose from food wise.”
                             </p>
                             <p> Jane Ellison</p>
                         </div>
             
                         <div className="svr-fa-stars-content">
                             <p>
                             {this.starBody(testimonyO)}
                             </p>
                         </div>
                     </aside>
             
                 </div>
             
             
             
             
                 <br />
             
             
             </div>
                 
                 )
         }
 /*svmay24 start*/
 getChildContainersList() {
        const {sjprobatecourtselectparent,sjofferselectparent,sjhotelselectparent, svofferMyFlyReservationSelectparent} = this
        //sojAndImagesSojourn
        /*sjjun12 start */
        const {sojAndImagesSojournMore} = this.props
         /*sjjun12 start */
     /*
             const {
             checkedWifi, checkedRestaurant, checkedPetfriendly, checkedRoomservice, checkedFitness, checkedFrontdesk, checkedNonsmoking, checkedShuttle, checkedFamilyrooms, checkedSpa, checkedEvcharging, checkedWheelchair, checkedPool,
             disabledWifi, disabledRestaurant, disabledPetfriendly, disabledRoomservice, disabledFitness, disabledFrontdesk, disabledNonsmoking, disabledShuttle, disabledFamilyrooms, disabledSpa, disabledEvcharging, disabledFWheelchair, disabledPool,
             checkedWifiLabel, checkedRestaurantLabel, checkedPetfriendlyabel, checkedRoomserviceLabel, checkedFitnessLabel, checkedFrontdeskLabel, checkedNonsmokingLabel, checkedShuttleLabel, checkedFamilyroomsLabel, checkedSpaLabel, checkedEvchargingLabel, checkedWheelchairLabel, checkedPoolLabel,
             checkedParking,checkedParkingLabel,disabledParking
     
     
             } = this.state.filters
             */
            const size = 'small'
             const legend = [{
                 "sojourncode": "100",
                 "vernacularcode": "EN",
                 "sojourn_name": "253 Mancreek Resort"
             },
             {
                 "sojourncode": "101",
                 "vernacularcode": "EN",
                 "sojourn_name": "253 John Resort"
             }]
             let customerId = -1
             let svCustomerId = -1
             const {dataProfile, svcustProfile} = this.props
             if(svcustProfile && svcustProfile.customerId > 0){
                 customerId = svcustProfile.customerId 
                 svCustomerId = customerId
                 console.log('myreservationSpace')
                 }else{
                  console.log('internet userSpace')
                 }
             let data = [], hosts = [], dbs = [], sojourns = [], my_data = [], hasMore = true, ctotal=1
             if (this.props.sosjournsearch.data && (this.props.sosjournsearch.data.length > 0)) {
                 data = this.props.sosjournsearch.data
             }
             if (this.props.sosjournsearch.sojourns && (this.props.sosjournsearch.sojourns.length > 0)) {
                 sojourns = this.props.sosjournsearch.sojourns
     
                 console.log('sv******************this.props')
                 console.log(this.props)
     
                 console.log('sv******************this.props....')
             }
             let my_data_tmp = null
             if (this.props.sosjournsearch && this.props.sosjournsearch.my_data && (this.props.sosjournsearch.my_data.length > 0)) {
                 my_data_tmp = this.props.sosjournsearch.my_data
             }else if(this.props.my_data && (this.props.my_data.length > 0)){
                 my_data_tmp = this.props.my_data
             }else{
                 my_data_tmp = []
             }

             if (this.props.sosjournsearch && this.props.sosjournsearch.hasMore && (this.props.sosjournsearch.hasMore != null )) {
                 hasMore = this.props.sosjournsearch.hasMore
             }else if(this.props.hasMore && (this.props.hasMore != null)){
                 hasMore = this.props.hasMore
             }else{
                 hasMore = true
             }
             console.log('sj***JUN13 this.props.sosjournsearch')
             console.log(this.props.sosjournsearch)
             if (this.props.sosjournsearch && (this.props.sosjournsearch.ctotal > 0)) {
                 ctotal = this.props.sosjournsearch.ctotal
             }else if(this.props.ctotal && (this.props.ctotal != null)){
                 ctotal = this.props.ctotal
             }else{
                 ctotal = 2
             }
             
             const {sv_esquery_data,my_scr_id} = this.props.sosjournsearch
             console.log('SJ******JUN20*invBoard*** GOT FACET DATA my_scr_id S', my_scr_id)
             console.log('sv_esquery_data***MUST**',sv_esquery_data)
             for(let i=0; i < my_data_tmp.length ; i++ ){
                 let r = my_data_tmp[i]
                 let my_ob = _.clone(r)
                 my_data.push(my_ob)
                 my_ob['svcustProfile'] = this.props.svcustProfile
                 my_ob['customerId'] = customerId
             }
             const {svessearch, locationDataView} = this.props
             console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master start')
             console.log(this.props)
             console.log('sv$$$$$$$$$$$$$$$$$$*****svcustProfile added')
             console.log(my_data)
             console.log('sv$$$$$$$$$$$$$$$$$$*****searchbar master end')
             /*
             if (this.props.loading) {
                 return <Loader type='spinner' />
             } else if (this.props.error) {
                 return <ErrorWidget error={this.props.error} />
             }
             */
            let testimonyO = {
             avg_stars_rating :5
            }
             return (
                 <div className="svr-det-pageWrapper">
                 <header className="svr-header1">
                 <h1><span><text style={{color:'#f0d8a9'}}>Choose Your Sojourn </text><Link to={`/myaccountSV/${svCustomerId}/svprofile`}> <Icon  style={{ color: '#eeb838' }} type="home" theme="filled" /> </Link></span> </h1>
                 </header>
                 <InvSearchBarBusCom />
                 
                 {/*  
                 <SearchBarBusCom />
                 <header className="svr-header2">
                     <h3>Cambsv Hotel Orlando Airport</h3>
                     <p> 7986 Conway Road, Orlando, 32812, United States of America – Excellent location – show map </p>
                 </header>
                 */}
             
             
                 <div className="svr-spacelist-contentWrapper">
                     {/*
                     <SJPageScroll></SJPageScroll>
                     firefix scrolling issue works in Safatri
                      <InvSearchBoardBody my_data={my_data}  sjofferselectparent={sjofferselectparent}></InvSearchBoardBody>
                             
                              <InvSearchBoardBodyPg sojAndImagesSojournMore={sojAndImagesSojournMore} hasMore={hasMore} my_data={my_data}  sjofferselectparent={sjofferselectparent}></InvSearchBoardBodyPg>
              
               <SJScroll  my_data={my_data}  ></SJScroll>
                      InvSJScroll

                        <InvSJScroll ctotal={ctotal} my_scr_id={my_scr_id} sv_esquery_data={sv_esquery_data}  my_data={my_data} sojAndImagesSojournMore={sojAndImagesSojournMore} hasMore={hasMore} my_data={my_data}  sjofferselectparent={sjofferselectparent}></InvSJScroll>
               
                     */}
                
                { this. getBoardBodyContainer_soj(sjprobatecourtselectparent,my_data,svofferMyFlyReservationSelectparent,sjofferselectparent,ctotal,my_scr_id,sv_esquery_data,sojAndImagesSojournMore,hasMore, sjhotelselectparent) }
           
               
               
                    
                     <aside className="siberbar2">
             
                         <h3> Filter By</h3>
                         <InvFacetBarBusCom  locationDataView={locationDataView} />
                         {/*  <FacetBarBusCom  locationDataView={locationDataView} /> */}
                         <div className="svr-rating-content">
                             <p className="svr-hotel-rating" >Excelllent 5.0
                             </p>
             
                         </div>
             
                         <div className="svr-num-reviews-content">
                             <p>12,364 reviews
                             </p>
             
                         </div>
                         <div className="svr-review-author-comment-content">
             
                             <p>“The property has a great bar/restaurant in the lobby, which is good because there isn't much
                                 around
                                 there to choose from food wise.”
                             </p>
                             <p> Jane Ellison</p>
                         </div>
             
                         <div className="svr-fa-stars-content">
                             <p>
                             {this.starBody(testimonyO)}
                             </p>
                         </div>
                     </aside>
             
                 </div>
             
             
             
             
                 <br />
             
             
             </div>
                 
                 )
         }
        
 /*svmay24 end*/
 sjofferselectparent_old(valuesChild,soj_rate_key,svcustProfile ){
     let me = this
   console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  OCT28  1 cookie1 from AmbLocation callback  flyboard svofferselectparent**********parent')
   console.log(valuesChild)
   console.log('^^^^^^^^^^^^ svcustProfile^^^^^^^^')
   console.log(svcustProfile)
   const { cookies } = this.props;
   console.log('sv*** MARCH27SV localStorage start')
   console.log(cookies)
   console.log('sv*** MARCH27SV localStorage end')
 
  /*
   const { cookies , localStorage} = this.props;
  console.log('sv*** MARCH27SV localStorage start')
  console.log(localStorage)
  console.log('sv*** MARCH27SV localStorage end')
*/
   if(cookies){
       let sjcookoffer_o = null
       console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')

       if(valuesChild ){
         let svcid = svcustProfile.customerId
         console.log('********NOV19**************** sv customerId ', svcid)
         let sjcookoffer_val = {}
           /*
            svcookoffer_val = {
               "type": "flight-offer",
               "id": "2",
               "source": "GDS",
               "instantTicketingRequired": false,
               "nonHomogeneous": false,
               "oneWay": false,
               "isUpsellOffer": false,
               "lastTicketingDate": "2024-10-27",
               "lastTicketingDateTime": "2024-10-27",
               "numberOfBookableSeats": 3,
               "itineraries": [
                   {
                       "duration": "PT9H15M",
                       "segments": [
                           {
                               "departure": {
                                   "iataCode": "JFK",
                                   "terminal": "5",
                                   "at": "2024-11-01T12:10:00"
                               },
                               "arrival": {
                                   "iataCode": "BOS",
                                   "terminal": "C",
                                   "at": "2024-11-01T13:22:00"
                               },
                               "carrierCode": "B6",
                               "number": "1318",
                               "aircraft": {
                                   "code": "E90"
                               },
                               "operating": {
                                   "carrierCode": "B6"
                               },
                               "duration": "PT1H12M",
                               "id": "1",
                               "numberOfStops": 0,
                               "blacklistedInEU": false
                           },
                           {
                               "departure": {
                                   "iataCode": "BOS",
                                   "terminal": "C",
                                   "at": "2024-11-01T15:00:00"
                               },
                               "arrival": {
                                   "iataCode": "LAX",
                                   "terminal": "5",
                                   "at": "2024-11-01T18:25:00"
                               },
                               "carrierCode": "B6",
                               "number": "387",
                               "aircraft": {
                                   "code": "32S"
                               },
                               "operating": {
                                   "carrierCode": "B6"
                               },
                               "duration": "PT6H25M",
                               "id": "2",
                               "numberOfStops": 0,
                               "blacklistedInEU": false
                           }
                       ]
                   }
               ],
               "price": {
                   "currency": "USD",
                   "total": "950.87",
                   "base": "861.67",
                   "fees": [
                       {
                           "amount": "0.00",
                           "type": "SUPPLIER"
                       },
                       {
                           "amount": "0.00",
                           "type": "TICKETING"
                       }
                   ],
                   "grandTotal": "950.87"
               },
               "pricingOptions": {
                   "fareType": [
                       "PUBLISHED"
                   ],
                   "includedCheckedBagsOnly": true
               },
               "validatingAirlineCodes": [
                   "B6"
               ],
               "travelerPricings": [
                   {
                       "travelerId": "1",
                       "fareOption": "STANDARD",
                       "travelerType": "ADULT",
                       "price": {
                           "currency": "USD",
                           "total": "950.87",
                           "base": "861.67"
                       },
                       "fareDetailsBySegment": [
                           {
                               "segmentId": "1",
                               "cabin": "ECONOMY",
                               "fareBasis": "MI3AUEY5",
                               "brandedFare": "AN",
                               "brandedFareLabel": "BLUE",
                               "class": "M",
                               "includedCheckedBags": {
                                   "quantity": 2
                               },
                               "amenities": [
                                   {
                                       "description": "CHECKED BAG FIRST",
                                       "isChargeable": true,
                                       "amenityType": "BAGGAGE",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "CHECKED BAG SECOND",
                                       "isChargeable": true,
                                       "amenityType": "BAGGAGE",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "EXTRA LEGROOM",
                                       "isChargeable": true,
                                       "amenityType": "PRE_RESERVED_SEAT",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "ADVANCE SEAT SELECTION",
                                       "isChargeable": false,
                                       "amenityType": "PRE_RESERVED_SEAT",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "SNACK",
                                       "isChargeable": false,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "ALCOHOLIC DRINK",
                                       "isChargeable": true,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "NON ALCOHOLIC DRINK",
                                       "isChargeable": false,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   }
                               ]
                           },
                           {
                               "segmentId": "2",
                               "cabin": "BUSINESS",
                               "fareBasis": "IC3GLE",
                               "brandedFare": "MN",
                               "brandedFareLabel": "MINT",
                               "class": "I",
                               "includedCheckedBags": {
                                   "quantity": 2
                               },
                               "amenities": [
                                   {
                                       "description": "LIE FLAT BED",
                                       "isChargeable": false,
                                       "amenityType": "PRE_RESERVED_SEAT",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "EXTRA LEGROOM",
                                       "isChargeable": false,
                                       "amenityType": "PRE_RESERVED_SEAT",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "ADVANCE SEAT SELECTION",
                                       "isChargeable": false,
                                       "amenityType": "PRE_RESERVED_SEAT",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "SNACK",
                                       "isChargeable": false,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "ALCOHOLIC DRINK",
                                       "isChargeable": false,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "NON ALCOHOLIC DRINK",
                                       "isChargeable": false,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   },
                                   {
                                       "description": "MEAL",
                                       "isChargeable": false,
                                       "amenityType": "MEAL",
                                       "amenityProvider": {
                                           "name": "BrandedFare"
                                       }
                                   }
                               ]
                           }
                       ]
                   }
               ]
           }
           */
           
           let svcustProfile_newcustomer = {
             "customerId": -6,
             "addressId":-1
         }
          if(!valuesChild['svcustProfile']){
             valuesChild['svcustProfile'] = svcustProfile_newcustomer
          }
          let svaluesChild = JSON.stringify(valuesChild)
          let size = svaluesChild.length
          console.log('********OCT25**************** SIZE OF  COOKIES  svcookoffer ', size)

          /*svnov20 start*/
          //we need to save in db based on sessionid or jwttoken genereate
          //and get that
          /*
          let toffer = valuesChild
          if(toffer && toffer["travelerPricings"] && toffer["travelerPricings"] ){
              let tars = toffer["travelerPricings"]
              for(let m=0; m <  tars.length; m++){
                  delete tars[m].fareDetailsBySegment
              }
          }
          */
         /*svnov20 start*/
          
           

         
           try{
               /*
             console.log(localStorage)
             localStorage.setItem('svcookls', svaluesChild);
             cookies.set('svcook', svaluesChild, { path: '/' });
             */
             cookies.set('sjcook', svaluesChild, { path: '/' });

           }catch(error){
             console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')

                console.log(error)}
          

           let m_offer = cookies.get('sjcook')
           console.log('********OCT25**************** TEST TO COOKIES SET sjcookoffer START', m_offer)
           /*svdec2 start */
           let my_data_sjtoffee ={
             "customerId": valuesChild['svcustProfile']['customerId'] ,
             "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
             "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
         } 
         my_data_sjtoffee.sjcook = svaluesChild
         console.log('********DEC4**************** expresseion sesion START ')
         /*
         save to redis
         this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
          

         */
         let expsessid_svt_s =  cookies.get('svabodeclientguest')
         console.log(expsessid_svt_s);
         
         let m_svt = expsessid_svt_s
         if(m_svt != null){
             my_data_sjtoffee['svt'] = m_svt
         }
         console.log('********DEC4**************** TEST TO COOKIES SET my_data_sjtoffee ')
         console.log(my_data_sjtoffee)
         console.log('********DEC4**************** expresseion sesion START ')
         
         // this.props.saveUserOffer({'my_data_sjtoffee' :my_data_sjtoffee})
          
         /*svdec2 end*/
           
         const udob ={
             "svcid": -2,
             "soj_rate_key":soj_rate_key
         
         }

         _.delay(()=>{
             console.log('sv****calling delauy DEC3 START'  )
             const { soj_rate_key} = udob
             let surl = `/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`
             console.log(surl)
             console.log('sv****calling delauy May26 end' )

             /*
             let surl = `/inetsojourn/shredfly/${soj_rate_key}`
             console.log(surl)
             console.log('sv****calling delauy DEC3 END' )
             history.push(`/inetsojourn/shredfly/${soj_rate_key}`)
            */
            /*svamy26mon  passing id and spaceKey to ShyReserveWithSearchPage wich calls SJReview*/
            history.push(`/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`)
         }, 400, udob);

         // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)

       }else{
           console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')

       }
       

   }
 
 }
/*sjjun19 start*/
getBoardBodyContainer_soj(sjprobatecourtselectparent,my_data,svofferMyFlyReservationSelectparent,sjofferselectparent,ctotal,my_scr_id,sv_esquery_data,sojAndImagesSojournMore,hasMore, sjhotelselectparent){
 if(this.props.sosjournsearch.error){
     console.log('sv**container ger errob')
     let errob = {
         "timestamp": "2015-08-23T02:27:18.038+0000",
         "status": 500,
         "error": "FlyServer Error",
         "message": "No Resulst Found.Please refinse search and try again",
         "path": "/kk/svaddressDetailPost"
     }
     let today_dt = new Date()
     errob["timestamp"] = today_dt
    return (
      <div >
         
          <div style={{paddingTop:'10px'}}>
            <ErrorCom  closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
          </div>
         
         
       </div>   
         )

   }else if(this.props.sosjournsearch.loading ){
    return (

      <div >
         <h3>Spinner*****</h3>
      <div style={{paddingTop:'10px'}}>
     

        <SVAbodeSpinner />
      </div>
     
     
   </div>   

    
          )

   }
 /*
   if (this.props.loading) {
return <Loader type='spinner' />
} else if (this.props.error) {
return <ErrorWidget error={this.props.error} />
}
*/
return (
      
    
      
                
               
 <InvSJScroll ctotal={ctotal} my_scr_id={my_scr_id} sv_esquery_data={sv_esquery_data}  my_data={my_data} sojAndImagesSojournMore={sojAndImagesSojournMore} hasMore={hasMore} my_data={my_data}  sjofferselectparent={sjofferselectparent} sjhotelselectparent={sjhotelselectparent} sjprobatecourtselectparent={sjprobatecourtselectparent} ></InvSJScroll>
                
)
}
/*sjjun19 end*/
}

export default InvSearchBoardContainer